import React from "react";
import UniversalForm from "../../../components/UniversalForm/UniversalForm";
import { useDealFormConfig, DealFormProps } from "../../../components/UniversalForm/entityForms";

const DealForm: React.FC<DealFormProps> = (props) => {
  const config = useDealFormConfig(props);
  return (
    <>
      <style>{`
        .deal-form-responsive {
          max-width: 615px;
          margin: 0 auto;
        }

        @media (min-width: 1024px) {
          .deal-form-responsive {
            max-width: 922px;
          }
        }
      `}</style>
      <div className="deal-form-responsive">
        <UniversalForm config={config} />
      </div>
    </>
  );
};

export default DealForm;
